import { render, staticRenderFns } from "./TopPagesGrid.vue?vue&type=template&id=754f67b0&scoped=true&"
import script from "./TopPagesGrid.vue?vue&type=script&lang=js&"
export * from "./TopPagesGrid.vue?vue&type=script&lang=js&"
import style0 from "./TopPagesGrid.vue?vue&type=style&index=0&id=754f67b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f67b0",
  null
  
)

/* custom blocks */
import block0 from "@/javascripts/grid.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fapp%2Fjavascript%2Fpages%2FDomainSearch%2FGrids%2FTopGrids%2FTopPagesGrid.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./TopPagesGrid.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports